import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-315">
      <div className="max-w-4xl mx-auto text-center" data-id="element-316">
        <div className="inline-flex items-center gap-2 border border-[#FF6B00]/50 text-[#FF6B00] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-317">
          🏆 Sistema N°1 para Profesores de Folklore en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-318">
          🥁 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#FF6B00] mb-6" data-id="element-319">
          MEGAPACK FOLKLORE LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-320">
          <strong data-id="element-321">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </strong>
          <br data-id="element-322" />
          +400 páginas · 24 clases modelo por tomo · 120+ guiones de corrección
          · Técnica · Danzas · Musicalidad Folklórica · Actos · Muestras ·
          Negocio. Funciona desde hoy.
        </p>

        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-323">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-324">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['Juego Rítmico', 'Danzas Base', 'Técnica', 'Malambo', 'Adultos', 'Maestro'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2 px-1 overflow-hidden" style={{
              backgroundColor: color,
              border: '2px solid #FF6B00'
            }} data-id="element-325">
                  <span className="text-white text-[8px] sm:text-xs font-bold text-center leading-tight break-words" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-326">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#FF6B00] font-black text-xs px-4 py-1 rounded-full whitespace-nowrap text-[#FFFFFF]" data-id="element-327">
            6 TOMOS COMPLETOS
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-8 max-w-2xl mx-auto" data-id="element-328">
          <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-329">
            ✅ Por nivel y edad
          </span>
          <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-330">
            ✅ 120+ guiones de clase
          </span>
          <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-331">
            ✅ Evaluación + rúbricas
          </span>
          <span className="bg-[#FF6B00]/10 text-[#FF6B00] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-332">
            ✅ Actos + Muestras + Negocio
          </span>
        </div>
      </div>
    </section>;
}